module.exports = __webpack_public_path__ + "img/rights_banner.8535f0d4.jpg";